<header class="header header--basic">

  <svg class="header__logo" viewBox="0 0 111 39.96">
    <use xlink:href="#ab-logo"></use>
  </svg>

</header>

<div class="content content--narrow vert-0500 center">

  <h1 class="h2">
    This invitation is not valid.
  </h1>

  <p class="large vert-0125">
    A member of your organization can send you a new invitation.
  </p>

  <p class="large vert-0075">
    If you previously accepted an invitation, visit the <a href="/login" class="link">login page</a>.
  </p>

</div>
